export default __webpack_public_path__ + "static/media/7.fc8e30fc.png";